import { createStore } from 'vuex';
import { getAuth, onAuthStateChanged, signOut, signInWithCustomToken, setPersistence, browserSessionPersistence} from "firebase/auth";
import gql from "graphql-tag";
import { apolloClient } from '../main'
import router from "../router/index"
import Swal from "sweetalert2"

const store = createStore({
    state () {
      return {
        isAuth: false,
        access_token: sessionStorage.getItem("token_access") || null,
        refresh_token: sessionStorage.getItem("token_refresh") || null,
      }
    },
    mutations: {
      verifyAuth (state, isAuth) {
            state.isAuth = isAuth;
      },

      refreshToken(state, access){
        state.access_token = access;
        sessionStorage.setItem("token_access", access);
      },

      mutateTokens(state, {access, refresh}){
        state.access_token = access;
        state.refresh_token = refresh;
        sessionStorage.setItem("token_access", access);
        sessionStorage.setItem("token_refresh", refresh);
        if(access === null || refresh === null){
          sessionStorage.clear();
        }
      }
    },
    actions: {
      async logInUser(context, user){
          try {
            let data = await apolloClient.mutate({
                mutation: gql`
                mutation Login($credentials: CredentialsInput!) {
                    login(credentials: $credentials) {
                        refresh
                        access
                        }
                    }
                `,
                variables: {
                    credentials: user,
                },
            })
            context.commit("mutateTokens", {access:data.data.login.access, refresh:data.data.login.refresh});

            const auth = getAuth();
            const token = this.state.access_token;
            setPersistence(auth, browserSessionPersistence)
                .then(()=>{
                    return signInWithCustomToken(auth, token)
                })
                .catch((error)=>{
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    sessionStorage.clear();
                })
            context.dispatch("verifyAuth");
            router.push({name:'Home'});
          } catch (error) {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'User or Password invalid'
              });              
          }
      },

      logOut(context){
        const auth = getAuth();
        signOut(auth).then(()=>{
            sessionStorage.clear();
            context.commit("verifyAuth", false);
            context.commit("mutateTokens", {access:null, refresh:null})
            router.push({name:'Home'});
        }).catch((error) => {
            // An error happened
            sessionStorage.clear();
            console.error(error);
        })
      },

      verifyAuth(context){
        const auth = getAuth();
        onAuthStateChanged(auth, (user)=>{
        if(user){
            context.commit("verifyAuth", true);
            context.dispatch("refreshToken");
        }
        else {
            context.commit("verifyAuth", false)
        }
        });
      },

      async refreshToken(context){
        try{
          let response = await apolloClient.mutate({
            mutation: gql`
              mutation RefreshToken($refresh: String!) {
                refreshToken(refresh: $refresh) {
                  access
                }
              }
            `,
            variables: {
              refresh: this.state.refresh_token,
            },
          });
          context.commit("refreshToken", response.data.refreshToken.access);
        }
        catch(err){
          context.dispatch("logOut")
        }
      },
    }
  })

export default store;